import { z } from 'zod';
// Brand content slot — spec §0b. One scheduled post per row. The unit
// the channel timeline ticks on.
export const brandContentSlotFormatSchema = z.enum([
    'post',
    'carousel',
    'reel',
    'story',
    'linkedin_post',
    'linkedin_article',
    'video',
]);
export const brandContentSlotPublishedViaSchema = z.enum([
    'mock',
    'meta_graph',
    'linkedin_api',
    'tiktok_api',
    'youtube_api',
    'manual',
]);
/** 47/N — per-slot approval state. Drives the JIT trigger + the
 *  slot_approval_pending feed card on /home. Matches the DB enum
 *  in migration 0163. */
export const brandContentSlotApprovalStatusSchema = z.enum([
    'not_required',
    'concept_only',
    'auto_prepping',
    'awaiting_designer',
    'final_pending',
    'approved',
    'rejected',
    'changes_requested',
]);
/** Per-slot draft. Same shape today's ContentPlanSlotDraft uses so
 *  the meta-post-draft agent can keep its output schema in Phase 0b.2. */
export const brandContentSlotDraftSchema = z.object({
    caption: z.string().min(1).max(2200),
    imageBrief: z.string().min(1).max(800),
    imageUrl: z.string().url().max(2048).optional(),
    videoUrl: z.string().url().max(2048).optional(),
    videoDurationSeconds: z.number().int().min(4).max(120).optional(),
    creativeAssetId: z.string().uuid().optional(),
});
export const brandContentSlotSchema = z.object({
    id: z.string().uuid(),
    organizationId: z.string().uuid(),
    brandId: z.string().uuid(),
    brandChannelId: z.string().uuid(),
    brandContentPlanId: z.string().uuid().nullable(),
    campaignId: z.string().uuid().nullable(),
    scheduledFor: z.string().datetime(),
    format: brandContentSlotFormatSchema,
    pillar: z.string().min(1).max(80),
    concept: z.string().min(1).max(280),
    rationale: z.string().nullable(),
    draft: brandContentSlotDraftSchema.nullable(),
    publishedAt: z.string().datetime().nullable(),
    publishedPostId: z.string().nullable(),
    publishedVia: brandContentSlotPublishedViaSchema.nullable(),
    rescheduledAt: z.string().datetime().nullable(),
    rescheduleReason: z.string().nullable(),
    draftCostCents: z.number().int().min(0),
    /** 47/N approval gate state. */
    approvalStatus: brandContentSlotApprovalStatusSchema.default('not_required'),
    approvalDecidedAt: z.string().datetime().nullable().default(null),
    approvalChangesNote: z.string().nullable().default(null),
    /** 50/N — per-slot creative-mode override. Null = inherit channel
     *  default. */
    creativeModeOverride: z.enum(['mag', 'designer']).nullable().default(null),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=brand-content-slot.js.map